import './index.css'
import logo from './logo.svg';
import React, { useState, useRef, useEffect} from 'react';
import './App.css';
import About from "./pages/About";
import Events from "./pages/Events";
import Navbar from './components/Navbar'; 
import CartPage from "./pages/Cart";
import PromoSection from './components/PromoSection';
import Beneficiaries from './pages/Beneficiaries';
import ShopPage from './pages/Shop';
import Checkout from './pages/Checkout';
import OrderConfirmationPage from './pages/OrderConfirmation';
import EventDetail from './pages/EventDetail';
import Footer from './components/Footer';  
import AdminLogin from './pages/AdminLogin';
import AdminOrders from './pages/AdminOrders';


import { Calendar, ShoppingBag, Heart, ShoppingCart } from 'lucide-react';
import { CartProvider } from './components/CartContext';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

// Test bundle hardcoded.
import bundle1 from './assets/images/bundle-1.png';
import bundle2 from './assets/images/bundle-2.png';
import bundle3 from './assets/images/bundle-3.png';
import bundle4 from './assets/images/bundle-4.png';
import bundle5 from './assets/images/bundle-5.png';
import bundle6 from './assets/images/bundle-6.png';

import { S3_IMAGES } from './config/s3Images';
import SpottedCarousel from './components/SpottedCarousel';
import ProductDetail from './pages/ProductDetail';
import BillingDetailsPage from './pages/OrderConfirmation';


// const events = [
//   {
//     title: "Early bird main carnival tickets $_",
//     buttonText: "Add",
//     icon: Calendar,
//     gradient: "from-gray-400 to-gray-300",
//   },
//   {
//     title: "Upcoming events",
//     buttonText: "Shop now",
//     icon: ShoppingBag,
//     gradient: "from-gray-400 to-gray-300",
//   },
//   {
//     title: "Donate via our Giving.sg",
//     buttonText: "Donate here",
//     icon: Heart,
//     gradient: "from-gray-400 to-gray-300",
//   },
// ];

// export const productsData = {
//   1: {
//     id: 1,
//     name: 'YOTY 25/26 Lineup Bundle',
//     price: 15,
//     image: bundle1,
//     description: 'Official NTU AFTH merchandise bundle featuring the complete YOTY 25/26 lineup. Show your pride with this exclusive design collection. High-quality fabric perfect for representing the community.',
//     images: [bundle1, bundle2, bundle3, bundle4],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   },
//   3: {
//     id: 3,
//     name: 'Limited Edition Graphic Tee Bundle',
//     price: 15,
//     image: bundle2,
//     description: 'Limited edition graphic tee collection featuring bold designs and premium quality materials. Stand out from the crowd with these exclusive pieces.',
//     images: [bundle2, bundle1, bundle3, bundle4],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   },
//   4: {
//     id: 4,
//     name: 'Festival Essentials Pack',
//     price: 15,
//     image: bundle3,
//     description: 'Everything you need for the ultimate festival experience. Comfortable, stylish, and built to last through all your favorite events.',
//     images: [bundle3, bundle2, bundle1, bundle4],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   },
//   5: {
//     id: 5,
//     name: 'Signature Event T-Shirt Set',
//     price: 15,
//     image: bundle4,
//     description: 'Signature collection of event t-shirts featuring iconic designs from our most memorable gatherings. Premium cotton blend for maximum comfort.',
//     images: [bundle4, bundle1, bundle2, bundle3],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   },
//   6: {
//     id: 6,
//     name: 'Urban Streetwear Classic Trio',
//     price: 15,
//     image: bundle5,
//     description: 'Classic urban streetwear collection that combines style and comfort. Perfect for everyday wear with a modern edge.',
//     images: [bundle5, bundle1, bundle2, bundle3],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   },
//   7: {
//     id: 7,
//     name: 'Heritage Collection Pack',
//     price: 15,
//     image: bundle6,
//     description: 'Celebrate our heritage with this special collection pack. Timeless designs that honor our roots and community spirit.',
//     images: [bundle6, bundle1, bundle2, bundle3],
//     sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL']
//   }
// };

  
function App() {
  // const products = [
  //   {
  //     title: "AFTH Carnival Pass",
  //     subtitle: "Experience the event your way.",
  //     tag: "TICKETS",
  //     tagColor: "bg-pink-200 text-pink-800",
  //     img: bundle1,
  //     bgColor: "bg-gradient-to-br from-purple-50 to-pink-50",
  //     textColor: "text-gray-900",
  //     buttonText: "Get Tickets",
  //   },
  //   {
  //     title: "Carnival Game Coupons",
  //     subtitle: "The final touch to your AFTH fun.",
  //     extraText: "From $2.00",
  //     img: bundle2,
  //     bgColor: "bg-gradient-to-br from-orange-400 to-orange-500",
  //     textColor: "text-white",
  //     buttonText: "Buy Coupons",
  //   },
  //   {
  //     title: "AFTH Merch Bundle",
  //     subtitle: "Exclusive tees & collectibles.",
  //     extraText: "Limited designs for this year's carnival.",
  //     highlight: "Claim your bundle now",
  //     tag: "LIMITED EDITION",
  //     tagColor: "bg-orange-200 text-orange-900",
  //     img: bundle3,
  //     bgColor: "bg-gradient-to-br from-orange-50 to-amber-50",
  //     textColor: "text-gray-900",
  //     buttonText: "Shop Merch",
  //   },
  // ];
  const API_BASE = process.env.REACT_APP_API_BASE;

  const [homeProducts, setHomeProducts] = useState([]);
  const [homeLoading, setHomeLoading] = useState(true);

  useEffect(() => {
    async function loadHomeProducts() {
      try {
        if (!API_BASE) {
          console.error("REACT_APP_API_BASE is missing");
          setHomeProducts([]);
          return;
        }

        const res = await fetch(`${API_BASE}/api/products`, {
          credentials: "include",
        });

        const data = await res.json();

        // backend should return { products: [...] }
        setHomeProducts(Array.isArray(data.products) ? data.products : []);
      } catch (err) {
        console.error("Failed to load home products:", err);
        setHomeProducts([]);
      } finally {
        setHomeLoading(false);
      }
    }

    loadHomeProducts();
  }, [API_BASE]);

  const [homeEvents, setHomeEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);

  useEffect(() => {
    async function loadHomeEvents() {
      try {
        if (!API_BASE) return;

        const res = await fetch(`${API_BASE}/api/events`, {
          credentials: "include",
        });
        const data = await res.json();
        const all = Array.isArray(data.events) ? data.events : [];

        // Only future events on the home page; if none, fall back to all
        const now = new Date();
        const upcoming = all.filter(
          (e) => e.date && new Date(e.date) >= now
        );
        setHomeEvents(upcoming.length ? upcoming : all);
      } catch (err) {
        console.error("Failed to load home events:", err);
        setHomeEvents([]);
      } finally {
        setEventsLoading(false);
      }
    }
    loadHomeEvents();
  }, [API_BASE]);

  const fmtDate = (d) =>
    d
      ? new Date(d).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })
      : "";

  // pick 4 events for the collage
  const featured = homeEvents.find((e) => e.featured) || homeEvents[0];
  const rest = homeEvents.filter((e) => e && featured && e.id !== featured.id);

  const e2 = rest[0];
  const e3 = rest[1];
  const e4 = rest[2];

  // Black Friday Landing Page Component
  const Home = () => (
    <div className="min-h-screen" style={{ backgroundColor: '#faf8f5' }}>
      {/* Hero Banner with responsive margin and height */}
      <div className="mx-auto px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8 animate-fade-in">
        <div className="relative overflow-hidden rounded-xl sm:rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500">
          <img 
            src={S3_IMAGES.HOME_HERO} 
            alt="AFTH Carnival" 
            className="w-full h-full sm:h-full md:h-full lg:h-h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
        </div>
      </div>

      {/* About Section - Mobile Optimized */}
      <div className="py-8 sm:py-12 md:py-16 animate-fade-in-delay">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="relative group">
            {/* Decorative background elements - reduced on mobile */}
            <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-pink-200 via-purple-200 to-orange-200 rounded-2xl sm:rounded-3xl opacity-20 blur-xl sm:blur-2xl group-hover:opacity-30 transition-all duration-700"></div>
            
            {/* Main card - responsive padding */}
            <div className="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 sm:border-4 border-transparent hover:border-pink-100">
              {/* Decorative corner elements - hidden on mobile */}
              <div className="hidden sm:block absolute top-0 left-0 w-16 h-16 md:w-20 md:h-20 border-t-4 border-l-4 border-orange-300 rounded-tl-3xl opacity-50"></div>
              <div className="hidden sm:block absolute bottom-0 right-0 w-16 h-16 md:w-20 md:h-20 border-b-4 border-r-4 border-purple-300 rounded-br-3xl opacity-50"></div>
              
              {/* Floating art elements - hidden on mobile */}
              <div className="hidden md:block absolute top-8 right-8 w-12 h-12 animate-float">
                <div className="w-full h-full bg-gradient-to-br from-pink-300 to-orange-300 rounded-full opacity-40 blur-sm"></div>
              </div>
              <div className="hidden md:block absolute bottom-12 left-12 w-16 h-16 animate-float-delayed">
                <div className="w-full h-full bg-gradient-to-br from-purple-300 to-pink-300 rounded-full opacity-30 blur-md"></div>
              </div>
              
<p className="text-gray-800 text-base sm:text-lg md:text-xl lg:text-2xl leading-relaxed text-center relative z-10">
  <span className="font-bold text-xl sm:text-2xl md:text-3xl bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent inline-block animate-gradient">
    NTU CAC Arts From The Heart (AFTH)
  </span>
  <br />
  <span className="text-base sm:text-lg md:text-xl mt-3 sm:mt-4 inline-block">
    is a <span className="font-semibold text-gray-900">special project</span> under NTU CAC.
  </span>
  <br />
  <span className="text-sm sm:text-base md:text-lg mt-2 sm:mt-3 inline-block text-gray-700">
    Since its inception in 2004, AFTH has consistently poured love into its mission 
    of supporting <span className="font-semibold text-gray-900">diverse charitable organisations</span>. 
    Our club has touched the lives of over <span className="font-bold text-xl sm:text-2xl text-gray-900">7,000 participants</span> and 
    built heartwarming partnerships with over <span className="font-bold text-xl sm:text-2xl text-gray-900">400 organisations</span>.
  </span>
</p>

              {/* Decorative line */}
              <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-1/2 sm:w-1/3 h-1 bg-gradient-to-r from-transparent via-pink-400 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Products Grid Section - Mobile Optimized (disabled for now) */}
      {false && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {homeLoading ? (
            <div className="col-span-1 sm:col-span-2 lg:col-span-3 p-6 text-gray-600">
              Loading products...
            </div>
          ) : (
            homeProducts.map((product, index) => (
              <Link
                to={`/product/${product.id}`}
                key={product.id}
                className="relative h-80 sm:h-96 overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer transform transition-all duration-700 hover:scale-105 animate-slide-up shadow-lg hover:shadow-2xl"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover transform transition-transform duration-1000 group-hover:scale-125 group-hover:rotate-2"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-70 group-hover:opacity-90 transition-all duration-500"></div>

                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/95 to-transparent p-4 sm:p-6 md:p-8 pb-6 sm:pb-8 md:pb-10 transform translate-y-4 group-hover:translate-y-0 transition-all duration-500">
                  <h3 className="text-white text-lg sm:text-xl md:text-2xl font-bold mb-1 sm:mb-2 transform transition-all duration-500 group-hover:translate-x-2 group-hover:text-pink-200 line-clamp-2">
                    {product.name}
                  </h3>
                  <p className="text-white/80 text-sm mb-3 sm:mb-4">
                    ${Number(product.price).toFixed(2)}
                  </p>
                  <button className="bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white px-6 sm:px-8 md:px-10 py-2 sm:py-3 rounded-full text-xs sm:text-sm font-bold transition-all duration-500 transform hover:scale-110 hover:shadow-xl hover:shadow-pink-500/50 active:scale-95 group-hover:animate-pulse-slow">
                    Shop now
                  </button>
                </div>
              </Link>
            ))
          )}
        </div>
      )}

    {/* Events Collage Section - Mobile Optimized */}
    <div className="mx-auto px-4 sm:px-6 md:px-8 pb-8 sm:pb-12 md:pb-16">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-10 md:mb-12 bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent px-4">
        Upcoming Events
      </h2>

      {eventsLoading ? (
        <div className="p-6 text-gray-600">Loading events...</div>
      ) : !featured ? (
        <div className="p-6 text-gray-600">No upcoming events yet.</div>
      ) : (
        <div className="grid grid-cols-12 gap-3 sm:gap-4 auto-rows-[160px] sm:auto-rows-[200px]">
          {/* Large Featured Event - Full width on mobile */}
          <Link
            to={`/event/${featured.id}`}
            className="col-span-12 md:col-span-6 row-span-2 relative overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500 block"
          >
            {featured.image && (
              <img
                src={featured.image}
                alt={featured.title}
                className="absolute inset-0 w-full h-full object-cover opacity-60"
              />
            )}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-pink-600 opacity-90"></div>
            <div className="hidden sm:block absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIgb3BhY2l0eT0iMC4xIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-30"></div>

            <div className="relative h-full p-4 sm:p-6 md:p-8 flex flex-col justify-between">
              <div>
                <span className="inline-block bg-white/20 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-white text-xs font-bold mb-2 sm:mb-4 animate-pulse">
                  FEATURED EVENT
                </span>
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3 leading-tight">
                  {featured.title}
                </h3>
                <p className="text-white/90 text-sm sm:text-base md:text-lg mb-2 sm:mb-4">
                  {featured.summary || "Click to view details"}
                </p>
              </div>
              <div>
                <div className="flex items-center gap-2 text-white mb-3 sm:mb-4">
                  <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span className="text-base sm:text-lg md:text-xl font-semibold">
                    {fmtDate(featured.date)}
                  </span>
                </div>
                <button className="bg-white text-purple-600 px-5 py-2 sm:px-6 sm:py-2.5 md:px-8 md:py-3 rounded-full text-sm sm:text-base font-bold hover:bg-purple-50 transition-all transform hover:scale-105">
                  Learn More
                </button>
              </div>
            </div>
          </Link>

          {/* Tall Card - Full width on mobile */}
          {e2 && (
            <Link
              to={`/event/${e2.id}`}
              className="col-span-12 md:col-span-6 row-span-2 relative overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500 block"
            >
              {e2.image && (
                <img
                  src={e2.image}
                  alt={e2.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-40"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-red-500 opacity-90"></div>
              <div className="hidden sm:block absolute top-0 right-0 w-48 h-48 sm:w-64 sm:h-64 bg-white/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>

              <div className="relative h-full p-4 sm:p-6 md:p-8 flex flex-col justify-between">
                <div>
                  <span className="inline-block bg-white/20 backdrop-blur-sm px-3 py-1 sm:px-4 sm:py-2 rounded-full text-white text-xs font-bold mb-2 sm:mb-4">
                    {String(e2.category || "EVENT").toUpperCase()}
                  </span>
                  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-2 sm:mb-3 leading-tight">
                    {e2.title}
                  </h3>
                  <p className="text-white/90 text-sm sm:text-base mb-2 sm:mb-4">
                    {e2.summary || "Click to view details"}
                  </p>
                </div>
                <div>
                  <div className="flex items-center gap-2 text-white mb-3 sm:mb-4">
                    <Calendar className="w-4 h-4 sm:w-5 sm:h-5" />
                    <span className="text-sm sm:text-base md:text-lg font-semibold">
                      {fmtDate(e2.date)}
                    </span>
                  </div>
                  <button className="bg-white/20 backdrop-blur-sm text-white border-2 border-white px-4 py-2 sm:px-6 sm:py-2.5 rounded-full text-sm sm:text-base font-bold hover:bg-white hover:text-orange-500 transition-all">
                    View
                  </button>
                </div>
              </div>
            </Link>
          )}

          {/* Small Square Cards - Half width on mobile */}
          {e3 && (
            <Link
              to={`/event/${e3.id}`}
              className="col-span-6 md:col-span-4 relative overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500 block"
            >
              {e3.image && (
                <img
                  src={e3.image}
                  alt={e3.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-br from-teal-500 to-blue-500 opacity-90"></div>
              <div className="hidden sm:block absolute top-0 left-0 w-full h-full opacity-20">
                <div className="absolute top-4 right-4 w-12 h-12 sm:w-16 sm:h-16 border-4 border-white rounded-full"></div>
                <div className="absolute bottom-4 left-4 w-8 h-8 sm:w-12 sm:h-12 border-4 border-white rounded-full"></div>
              </div>

              <div className="relative h-full p-3 sm:p-4 md:p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2 leading-tight">
                    {e3.title}
                  </h3>
                  <p className="text-white/90 text-xs mb-2 sm:mb-3">
                    {e3.summary || "Click to view details"}
                  </p>
                </div>
                <div>
                  <div className="flex items-center gap-1 sm:gap-2 text-white mb-2 sm:mb-3">
                    <Calendar className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="text-xs font-semibold">{fmtDate(e3.date)}</span>
                  </div>
                  <button className="bg-white/20 backdrop-blur-sm text-white text-xs px-3 py-1.5 sm:px-4 sm:py-2 rounded-full font-bold hover:bg-white hover:text-teal-500 transition-all">
                    View
                  </button>
                </div>
              </div>
            </Link>
          )}

          {e4 && (
            <Link
              to={`/event/${e4.id}`}
              className="col-span-6 md:col-span-4 relative overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500 block"
            >
              {e4.image && (
                <img
                  src={e4.image}
                  alt={e4.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-30"
                />
              )}
              <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 to-purple-600 opacity-90"></div>
              <div className="hidden sm:block absolute bottom-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-white/10 rounded-full blur-2xl"></div>

              <div className="relative h-full p-3 sm:p-4 md:p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2 leading-tight">
                    {e4.title}
                  </h3>
                  <p className="text-white/90 text-xs mb-2 sm:mb-3">
                    {e4.summary || "Click to view details"}
                  </p>
                </div>
                <div>
                  <div className="flex items-center gap-1 sm:gap-2 text-white mb-2 sm:mb-3">
                    <Calendar className="w-3 h-3 sm:w-4 sm:h-4" />
                    <span className="text-xs font-semibold">{fmtDate(e4.date)}</span>
                  </div>
                  <button className="bg-white/20 backdrop-blur-sm border-2 border-white text-white text-xs px-3 py-1.5 sm:px-4 sm:py-2 rounded-full font-bold hover:bg-white hover:text-indigo-600 transition-all">
                    View
                  </button>
                </div>
              </div>
            </Link>
          )}
        </div>
      )}
    </div>


          {/* <div className="col-span-6 md:col-span-4 relative overflow-hidden rounded-2xl sm:rounded-3xl group cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500">
            <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 to-purple-600 opacity-90"></div>
            <div className="hidden sm:block absolute bottom-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-white/10 rounded-full blur-2xl"></div>
            
            <div className="relative h-full p-3 sm:p-4 md:p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-white mb-1 sm:mb-2 leading-tight">
                  Pop Dance Night
                </h3>
                <p className="text-white/90 text-xs mb-2 sm:mb-3">Celebrating diversity through dance</p>
              </div>
              <div>
                <div className="flex items-center gap-1 sm:gap-2 text-white mb-2 sm:mb-3">
                  <Calendar className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span className="text-xs font-semibold">March 8, 2025</span>
                </div>
                <button className="bg-white/20 backdrop-blur-sm border-2 border-white text-white text-xs px-3 py-1.5 sm:px-4 sm:py-2 rounded-full font-bold hover:bg-white hover:text-indigo-600 transition-all">
                  Book Now
                </button>
              </div>
            </div>
          </div> */}

      {/* CSS Animations */}
      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(40px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) translateX(0px);
          }
          50% {
            transform: translateY(-20px) translateX(10px);
          }
        }

        @keyframes sparkle {
          0%, 100% {
            opacity: 0;
            transform: scale(0);
          }
          50% {
            opacity: 1;
            transform: scale(1.5);
          }
        }

        @keyframes gradient {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes pulse-slow {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }

        .animate-fade-in-delay {
          animation: fade-in 1s ease-out 0.3s both;
        }

        .animate-slide-up {
          animation: slide-up 0.8s ease-out both;
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animate-float-delayed {
          animation: float 8s ease-in-out infinite 2s;
        }

        .animate-sparkle {
          animation: sparkle 2s ease-in-out infinite;
        }

        .animate-sparkle-delayed {
          animation: sparkle 2s ease-in-out infinite 0.5s;
        }

        .animate-gradient {
          background-size: 200% 200%;
          animation: gradient 5s ease infinite;
        }

        .animate-spin-slow {
          animation: spin-slow 20s linear infinite;
        }

        .animate-pulse-slow {
          animation: pulse-slow 2s ease-in-out infinite;
        }

        /* Prevent text overflow on mobile */
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        /* Smooth touch interactions */
        @media (hover: none) {
          .group:hover {
            transform: none;
          }
        }
      `}</style>

      {/* Footer - Mobile Optimized
      <footer className="bg-white/80 backdrop-blur-sm border-t border-gray-200 py-8 sm:py-10 md:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
            <div>
              <h4 className="font-bold mb-3 sm:mb-4 text-sm sm:text-base">Shop</h4>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li><a href="#" className="hover:text-gray-900 transition-colors">All Products</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Notebooks</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Planners</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Accessories</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3 sm:mb-4 text-sm sm:text-base">About</h4>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li><a href="#" className="hover:text-gray-900 transition-colors">Our Story</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Retailers</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Blog</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3 sm:mb-4 text-sm sm:text-base">Support</h4>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li><a href="#" className="hover:text-gray-900 transition-colors">Contact</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Shipping</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Returns</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3 sm:mb-4 text-sm sm:text-base">Follow Us</h4>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li><a href="#" className="hover:text-gray-900 transition-colors">Instagram</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">Pinterest</a></li>
                <li><a href="#" className="hover:text-gray-900 transition-colors">LinkedIn</a></li>
              </ul>
            </div>
          </div>
          <div className="mt-8 sm:mt-10 md:mt-12 pt-6 sm:pt-8 border-t border-gray-200 text-center text-xs sm:text-sm text-gray-600">
            <p>© 2025 NTU AFTH Creative tools. All rights reserved.</p>
          </div>
        </div>
      </footer> */}
    </div>
  );

  return (
    <CartProvider>
      <Router>
        <div className="App">
          <Navbar />  

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/event/:id" element={<EventDetail />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/beneficiaries" element={<Beneficiaries />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            {/* Order confirmation supports both state-based and URL-based navigation */}
            <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
            <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
          </Routes>
                    <Footer />

        </div>
      </Router>
    </CartProvider>
  );
}

export default App;
